(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clover-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clover-recently-viewed')) {
  customElements.define('clover-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      const key = 'cloverRecentlyViewedHandles';
      const current = this.dataset.handle;
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(stored)) history = stored.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h));
      } catch {}
      const previous = [...new Set(history)].filter(h => h !== current).slice(0,4);
      try { localStorage.setItem(key, JSON.stringify([current, ...previous].slice(0,5))); } catch {}
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      const products = await Promise.all(previous.map(async handle => {
        try {
          const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {signal:AbortSignal.timeout(8000)});
          if (!response.ok) return null;
          return await response.json();
        } catch { return null; }
      }));
      if (!this.isConnected) return;
      const list = this.querySelector('ul');
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      products.filter(Boolean).forEach(product => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = root + 'products/' + encodeURIComponent(product.handle);
        if (product.featured_image) {
          const img = document.createElement('img');
          const imageUrl = new URL(product.featured_image, location.origin);
          if (imageUrl.protocol === 'https:') {
            imageUrl.searchParams.set('width','360');
            img.src = imageUrl.href;
            img.alt = product.title;
            img.width = 180;
            img.height = 180;
            img.loading = 'lazy';
            link.append(img);
          }
        }
        const title = document.createElement('span');
        title.className = 'clover-recent-title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'clover-recent-price';
        price.textContent = formatter.format(product.price / 100);
        link.append(title, price);
        if (!product.available) {
          const status = document.createElement('span');
          status.textContent = this.dataset.soldOut;
          link.append(status);
        }
        item.append(link);
        list.append(item);
      });
      this.hidden = !list.children.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
